import(/* webpackMode: "eager", webpackExports: ["Accordion"] */ "/home/ubuntu/html/tablespace-website/components/Accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DaysCountVideo"] */ "/home/ubuntu/html/tablespace-website/components/DaysCountVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArrowScroller"] */ "/home/ubuntu/html/tablespace-website/components/gcc/ArrowScroller.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GccFootprint"] */ "/home/ubuntu/html/tablespace-website/components/gcc/GccFootprint.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatFigure"] */ "/home/ubuntu/html/tablespace-website/components/gcc/StatFigure.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeadForm"] */ "/home/ubuntu/html/tablespace-website/components/LeadForm.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/html/tablespace-website/components/Motion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollFadeHero"] */ "/home/ubuntu/html/tablespace-website/components/ScrollFadeHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/html/tablespace-website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/html/tablespace-website/node_modules/next/dist/client/image-component.js");
